<script>
import General from '@/services/General'
import Customers from '@/services/Customers'
import Notification from '@/services/Notification'
import validationMessages from '@/components/validations'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from "vuelidate/lib/validators"
import moment from "moment"
import flatPickr from "vue-flatpickr-component"
import vue2Dropzone from "vue2-dropzone"

import "flatpickr/dist/flatpickr.css"
import "vue2-dropzone/dist/vue2Dropzone.min.css"
// import "vue-multiselect/dist/vue-multiselect.min.css"

export default {
  mixins: [validationMixin],
  components: {
    validationMessages,
    flatPickr,
    vueDropzone: vue2Dropzone,
  },
  props: {
    showSectionData: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const defaultStartDate = moment().format("YYYY-MM-DD")
    const defaultEndDate = moment().add(7, 'days').format("YYYY-MM-DD")

    return {
      showModal: false,
      tryingToSubmit: false,
      submitted: false,
      acceptedFileTypeErrorMessage: '',
      acceptedFileTypeError: false,
      dateRangeError: '',
      actionTextOption: [],
      showSecondLevelSelect: false,
      secondLevelOptions: [],
      secondLevelKey: '',
      secondLevelTitle: '',
      secondLevelLoading: false,
      selectedSecondLevel: '',
      popupTypeOptions: [
        { value: 'url', text: 'URL (External Link)' },
        { value: 'deeplink', text: 'Deep Link (App Section)' },
      ],
      recipientOptions: [
        { value: 'ALL', text: 'All Users' },
        { value: 'IOS', text: 'IOS Users' },
        { value: 'ANDROID', text: 'Android Users' },
        { value: 'GROUP', text: 'Group' },
      ],
      popup: {
        name: '',
        title: '',
        bottom_text: '',
        action: '',
        action_text: '',
        type: '',
        selectedShowSection: '',
        participation_agreement_text: '',
        participation_tnc_url: '',
        recipient: 'ALL',
        group: '',
        file: null,
      },
      duration: {
        start_date: defaultStartDate,
        start_time: '00:00',
        end_date: defaultEndDate,
        end_time: '23:59',
      },
      startDateConfig: {
        dateFormat: "Y-m-d",
        minDate: "today",
      },
      endDateConfig: {
        dateFormat: "Y-m-d",
        minDate: "today",
      },
      timePickerConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minuteIncrement: 1,
        allowInput:true,
        allowInvalidPreload: false,
        clickOpens: true,

      },
      dropzoneOptions: {
        url: '/',
        autoProcessQueue: false,
        addRemoveLinks: false,
        thumbnailWidth: 150,
        thumbnailMethod: 'contain',
        maxFilesize: 1,
        maxFiles: 1,
        acceptedFiles: 'image/jpeg,image/png',
        dictMaxFilesExceeded: 'You can only upload one image',
        dictFileTooBig: 'Image is larger than 1MB',
        uploadMultiple: false,
      },
      csrf_token: localStorage.getItem('csrf_token'),
      hasSavedDraft: false,
      savedDraft: null,
      systemGroups: [],
      userCreatedGroups: [],
      selectedSystemGroupId: '',
      selectedUserGroup: null,
      userGroupSearch: '',
      estimatedAudienceCount: null,
      estimatedAudienceLoading: false,
      estimatedAudienceRequestId: 0,
      /** Object URL for uploaded image — preview (revoked on change/destroy). */
      previewImageObjectUrl: '',
      /** App button colors from `General.getAppButtonColors()` — same as modalPreviewHypePopUp. */
      appButtonColor: '#ff6b35',
      appButtonTextColor: '#ffffff',
      isLoadingParams: false,
    };
  },
  validations: {
    popup: {
      name: { required },
      title: {
        required: requiredIf(function () {
          return this.typeIsParticipation
        })
      },
      bottom_text: {
        required: requiredIf(function () {
          return this.typeIsParticipation
        })
      },
      participation_agreement_text: {
        required: requiredIf(function () {
          return this.typeIsParticipation
        })
      },
      participation_tnc_url: {
        required: requiredIf(function () {
          return this.typeIsParticipation
        })
      },
      type: { required },
      selectedShowSection: {
        required: requiredIf(function () {
          return this.typeIsDeeplink
        })
      },
      file: { required },
      recipient: { required },
      group: {
        required: requiredIf(function () {
          return this.popup.recipient === 'GROUP'
        })
      }
    },
    duration: {
      start_date: { required },
      start_time: { required },
      end_date: { required },
      end_time: { required },
    },
    selectedSecondLevel: {
      required: requiredIf(function () {
        return this.typeIsDeeplink && this.showSecondLevelSelect
      })
    }
  },
  created() {
    this.getCustomersGroups()
  },
  computed: {
    popupType: {
      get() {
        return this.popup.type
      },
      set(value) {
        this.popup.type = value
      }
    },
    typeIsParticipation() {
      return this.popupType === 'participation'
    },
    typeIsUrl() {
      return this.popupType === 'url'
    },
    typeIsWebview() {
      return this.popupType === 'webview'
    },
    typeIsDeeplink() {
      return this.popupType === 'deeplink'
    },
    hasGroupSelection() {
      return this.popup.recipient === 'GROUP'
    },
    filteredUserCreatedForSearch() {
      const q = (this.userGroupSearch || '').trim().toLowerCase()
      const list = this.userCreatedGroups
      if (!q) {
        return list
      }
      return list.filter((g) => (g.name || '').toLowerCase().includes(q))
    },
    estimatedAudienceDisplay() {
      if (this.estimatedAudienceCount == null || this.estimatedAudienceCount === '') {
        return '—'
      }
      const n = Number(this.estimatedAudienceCount)
      if (Number.isNaN(n)) {
        return '—'
      }
      return n.toLocaleString()
    },
    selectedSystemGroup() {
      if (!this.selectedSystemGroupId) {
        return null
      }
      return this.systemGroups.find((g) => g.group_id === this.selectedSystemGroupId) || null
    },
    activeAudienceLabel() {
      if (this.selectedSystemGroup) {
        return (this.selectedSystemGroup.name || '').trim()
      }
      if (this.selectedUserGroup) {
        return (this.selectedUserGroup.name || '').trim()
      }
      return ''
    },
    hasActiveAudience() {
      return !!(this.selectedSystemGroupId || this.selectedUserGroup)
    },
    formattedStartDateTime() {
      return this.combineDateTime(this.duration.start_date, this.duration.start_time)
    },
    formattedEndDateTime() {
      return this.combineDateTime(this.duration.end_date, this.duration.end_time)
    },
    /** Resolved button label for preview (mirrors createHypePopUp defaults when field is empty). */
    resolvedPreviewActionText() {
      const raw = (this.popup.action_text || '').trim()
      if (raw) {
        return raw
      }
      if (!this.actionTextOption.length) {
        return ''
      }
      const defaultOption = this.actionTextOption[0]
      const participationOption = this.actionTextOption[2] || defaultOption
      const deeplinkOption = this.actionTextOption[1] || defaultOption
      if (this.typeIsParticipation) {
        return participationOption
      }
      if (this.typeIsDeeplink) {
        return deeplinkOption
      }
      return defaultOption
    },
    /** Shape expected by the preview phone mockup (same fields as modalPreviewHypePopUp `popupsData`). */
    hypePreviewPopupsData() {
      return {
        background_image: this.previewImageObjectUrl || null,
        title: this.popup.title || '',
        action_text: this.resolvedPreviewActionText,
        type: this.popup.type || '',
        participation_tnc_url: this.popup.participation_tnc_url || '',
      }
    },
  },
  beforeDestroy() {
    if (this.previewImageObjectUrl) {
      URL.revokeObjectURL(this.previewImageObjectUrl)
    }
  },
  methods: {
    async loadAppButtonColors() {
      this.isLoadingParams = true
      try {
        const colors = await General.getAppButtonColors()
        Object.assign(this, colors)
      } catch (error) {
        console.error('Failed to load app params:', error)
      } finally {
        this.isLoadingParams = false
      }
    },
    formatActionText(text) {
      if (!text) return 'Buy Now'
      if (text === 'MARKETING_POPUP_ACTION_WEBSITE') {
        return 'Visit Website'
      }
      if (text === 'MARKETING_POPUP_ACTION_DEEPLINK') {
        return 'Open'
      }
      if (text.includes('_')) {
        const formatted = text
          .split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ')
          .replace(/^Marketing Popup Action /i, '')
          .replace(/^Action /i, '')
        return formatted || 'Buy Now'
      }
      return text
    },
    getHypePreviewImageUrl() {
      return this.hypePreviewPopupsData.background_image || null
    },
    onHypeModalShown() {
      this.getActionTextOptions()
      this.fetchEstimatedAudience()
      this.loadAppButtonColors()
    },
    getCustomersGroups() {
      Customers.getCustomersGroups()
        .then((response) => {
          const rows = response.data.data ? response.data.data : []
          this.systemGroups = rows.filter((g) => Number(g.active) === 1)
          this.userCreatedGroups = rows.filter((g) => g.type === 'static' && Number(g.active) === 1)
        })
        .catch(() => {
          this.systemGroups = []
          this.userCreatedGroups = []
        })
    },
    async fetchEstimatedAudience() {
      const recipient = this.popup.recipient || 'ALL'
      if (!recipient) {
        this.estimatedAudienceCount = null
        return
      }

      if (recipient === 'GROUP') {
        const group_id =
          this.selectedSystemGroupId ||
          (this.selectedUserGroup && this.selectedUserGroup.group_id) ||
          ''
        if (!group_id) {
          this.estimatedAudienceLoading = false
          this.estimatedAudienceCount = null
          return
        }
      }

      const requestId = ++this.estimatedAudienceRequestId
      this.estimatedAudienceLoading = true

      let filters = ''
      if (recipient === 'GROUP') {
        const group_id =
          this.selectedSystemGroupId ||
          (this.selectedUserGroup && this.selectedUserGroup.group_id) ||
          ''
        filters = `&group_id=${encodeURIComponent(group_id)}`
      }

      try {
        const response = await Notification.getAudience(recipient, filters)
        const total =
          response && response.data && typeof response.data.total !== 'undefined'
            ? response.data.total
            : null
        if (requestId === this.estimatedAudienceRequestId) {
          this.estimatedAudienceCount = total != null ? Number(total) : null
        }
      } catch (e) {
        if (requestId !== this.estimatedAudienceRequestId) {
          return
        }
        if (recipient === 'GROUP') {
          if (this.selectedSystemGroupId) {
            const g = this.systemGroups.find((x) => x.group_id === this.selectedSystemGroupId)
            this.estimatedAudienceCount = g && g.total_members != null ? g.total_members : null
            return
          }
          if (this.selectedUserGroup && this.selectedUserGroup.total_members != null) {
            this.estimatedAudienceCount = this.selectedUserGroup.total_members
            return
          }
        }
        this.estimatedAudienceCount = null
      } finally {
        if (requestId === this.estimatedAudienceRequestId) {
          this.estimatedAudienceLoading = false
        }
      }
    },
    onSystemGroupChange() {
      if (this.selectedSystemGroupId) {
        this.selectedUserGroup = null
        this.userGroupSearch = ''
        this.popup.group = this.selectedSystemGroupId
      } else {
        this.popup.group = this.selectedUserGroup ? this.selectedUserGroup.group_id : ''
      }
      this.fetchEstimatedAudience()
    },
    clearSystemGroupSelection() {
      this.selectedSystemGroupId = ''
      this.popup.group = this.selectedUserGroup ? this.selectedUserGroup.group_id : ''
      this.fetchEstimatedAudience()
    },
    pickUserCreatedGroup(group) {
      this.selectedUserGroup = { ...group }
      this.selectedSystemGroupId = ''
      this.userGroupSearch = ''
      this.popup.group = group.group_id
      this.fetchEstimatedAudience()
    },
    clearUserCreatedSelection() {
      this.selectedUserGroup = null
      this.userGroupSearch = ''
      this.popup.group = this.selectedSystemGroupId || ''
      this.fetchEstimatedAudience()
    },
    clearActiveAudience() {
      if (this.selectedSystemGroupId) {
        this.clearSystemGroupSelection()
      } else if (this.selectedUserGroup) {
        this.clearUserCreatedSelection()
      }
    },
    onRecipientChange() {
      if (this.popup.recipient !== 'GROUP') {
        this.popup.group = ''
        this.selectedSystemGroupId = ''
        this.selectedUserGroup = null
        this.userGroupSearch = ''
      }
      this.fetchEstimatedAudience()
    },
    refreshEstimatedAudience() {
      this.fetchEstimatedAudience()
    },
    refreshPopupData() {
      this.$emit('onRefresh')
    },
    combineDateTime(date, time) {
      if (!date || !time) {
        return ''
      }
      return moment(`${date} ${time}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm")
    },
    validateDateRange() {
      this.dateRangeError = ''
      if (!this.formattedStartDateTime || !this.formattedEndDateTime) {
        return false
      }
      if (moment(this.formattedEndDateTime).isBefore(moment(this.formattedStartDateTime))) {
        this.dateRangeError = 'End date must be after start date.'
        return false
      }
      return true
    },
    async createHypePopUp() {
      if (this.acceptedFileTypeError) {
        return
      }
      this.tryingToSubmit = true
      this.submitted = true
      this.$v.$touch()

      const hasValidRange = this.validateDateRange()
      if (this.$v.$invalid || !hasValidRange) {
        this.tryingToSubmit = false
        return
      }

      // Set default action_text if empty based on popup type
      let actionTextToSend = this.popup.action_text
      if (!actionTextToSend || actionTextToSend.trim() === '') {
        if (this.actionTextOption.length > 0) {
          const defaultOption = this.actionTextOption[0]
          const participationOption = this.actionTextOption[2] || defaultOption
          const deeplinkOption = this.actionTextOption[1] || defaultOption

          if (this.typeIsParticipation) {
            actionTextToSend = participationOption
          } else if (this.typeIsDeeplink) {
            actionTextToSend = deeplinkOption
          } else {
            actionTextToSend = defaultOption
          }
        }
      }

      const formData = new FormData()
      formData.append('name', this.popup.name)
      formData.append('title', this.popup.title)
      formData.append('bottom_text', this.popup.bottom_text)
      formData.append('action_text', actionTextToSend)
      formData.append('type', this.popupType)

      if (this.typeIsParticipation) {
        formData.append('participation_agreement_text', this.popup.participation_agreement_text)
        formData.append('participation_tnc_url', this.popup.participation_tnc_url)
      } else {
        formData.append('participation_agreement_text', '')
        formData.append('participation_tnc_url', '')
      }

      if (this.typeIsUrl || this.typeIsWebview) {
        formData.append('action', this.popup.action)
      } else if (this.typeIsDeeplink) {
        formData.append('action', this.popup.selectedShowSection || '')
      } else {
        formData.append('action', '')
      }

      if (this.typeIsDeeplink) {
        formData.append('show_section', this.popup.selectedShowSection)
        formData.append('second_level', this.showSecondLevelSelect ? this.selectedSecondLevel : '')
        formData.append('second_level_key', this.secondLevelKey || '')
      } else {
        formData.append('show_section', '')
        formData.append('second_level', '')
      }

      formData.append('date_from', this.formattedStartDateTime)
      formData.append('date_to', this.formattedEndDateTime)
      formData.append('file', this.popup.file)
      formData.append('recipient', this.popup.recipient)
      formData.append('csrf_token', this.csrf_token)

      if (this.hasGroupSelection) {
        formData.append('group_id', this.popup.group)
      }

      await General.createHypePopUp(formData).then((response) => {
            this.successmsg('Marketing Popup Created!')
            //this.saveHypePopupDraft()
            this.refreshPopupData()
            this.closeModal()
        })
        .catch(error => {
          const resData = error?.response?.data?.error ? error.response.data.error : 'Failed'
          const errorMsg = Array.isArray(resData) ? resData[0] : resData
          this.failedmsg(errorMsg)
        })
        .finally(() => {
          this.tryingToSubmit = false
        })
    },
    closeModal() {
      this.showModal = false
    },
    resetProps() {
      const defaultStartDate = moment().format("YYYY-MM-DD")
      const defaultEndDate = moment().add(7, 'days').format("YYYY-MM-DD")

      if (this.previewImageObjectUrl) {
        URL.revokeObjectURL(this.previewImageObjectUrl)
        this.previewImageObjectUrl = ''
      }
      this.submitted = false
      this.acceptedFileTypeErrorMessage = ''
      this.acceptedFileTypeError = false
      this.dateRangeError = ''
      this.popup = {
        name: '',
        title: '',
        bottom_text: '',
        action: '',
        action_text: '',
        type: '',
        selectedShowSection: '',
        participation_agreement_text: '',
        participation_tnc_url: '',
        recipient: 'ALL',
        group: '',
        file: null,
      }
      this.selectedSystemGroupId = ''
      this.selectedUserGroup = null
      this.userGroupSearch = ''
      this.estimatedAudienceCount = null
      this.estimatedAudienceLoading = false
      this.estimatedAudienceRequestId = 0
      this.duration = {
        start_date: defaultStartDate,
        start_time: '00:00',
        end_date: defaultEndDate,
        end_time: '23:59',
      }
      this.resetSecondLevelState()

      if (this.$refs.hypeDropzone) {
        this.$refs.hypeDropzone.removeAllFiles(true)
      }
    },
    selectFile(files) {
      setTimeout(() => {
        const dropzoneFiles = this.$refs.hypeDropzone?.dropzone?.files || []
        const [file] = files
        if (!file) {
          return
        }

        if (file.size > 1048576) {
          this.acceptedFileTypeErrorMessage = 'Max file size is 1MB.'
          this.acceptedFileTypeError = true
        } else if (!['image/png', 'image/jpeg'].includes(file.type)) {
          this.acceptedFileTypeErrorMessage = 'Only PNG or JPG images are allowed.'
          this.acceptedFileTypeError = true
        } else {
          this.acceptedFileTypeErrorMessage = ''
          this.acceptedFileTypeError = false
        }

        if (dropzoneFiles.length > 1) {
          dropzoneFiles.forEach((value, index) => {
            if (index !== 0) {
              this.$refs.hypeDropzone.removeFile(value)
            }
          })
        }

        this.popup.file = !this.acceptedFileTypeError ? dropzoneFiles[0] : null
      }, 200)
    },
    removeImage() {
      if (this.$refs.hypeDropzone) {
        this.$refs.hypeDropzone.removeAllFiles(true)
      }
      this.popup.file = null
    },
    getActionTextOptions() {
      General.getactionTextOptions()
        .then((response) => {
          this.actionTextOption = response.data.data ? response.data.data : []
          // Don't auto-populate on initial load - let user manually enter or change popup type
        })
        .catch(() => {
          this.actionTextOption = []
        })

      this.checkForSavedDraft()
    },
    resetSecondLevelState() {
      this.secondLevelOptions = []
      this.secondLevelKey = ''
      this.secondLevelTitle = ''
      this.selectedSecondLevel = ''
      this.showSecondLevelSelect = false
      this.secondLevelLoading = false
      if (this.$v?.selectedSecondLevel?.$reset) {
        this.$v.selectedSecondLevel.$reset()
      }
    },
    handleShowSectionChange(method) {
      this.resetSecondLevelState()
      if (!method || !this.typeIsDeeplink) {
        return
      }
      const selectedSection = this.showSectionData.find(section => section.method === method)
      if (!selectedSection || !selectedSection.second_level) {
        return
      }
      this.secondLevelKey = selectedSection.second_level
      this.secondLevelTitle = selectedSection.second_level_description || 'Select an option'
      this.secondLevelLoading = true
      this.getDeeplinkSecondLevel(selectedSection.second_level)
    },
    getDeeplinkSecondLevel(second_level) {
      General.getDeeplinkSecondLevelOptions(second_level)
        .then(response => {
          this.secondLevelOptions = response.data.data || []
          this.showSecondLevelSelect = this.secondLevelOptions.length > 0
        })
        .catch(() => {
          this.secondLevelOptions = []
          this.showSecondLevelSelect = false
        })
        .finally(() => {
          this.secondLevelLoading = false
        })
    },
    syncActionText() {
      if (!this.actionTextOption.length) {
        return
      }

      // Only auto-populate if user hasn't manually entered a value
      if (this.popup.action_text && this.popup.action_text.trim() !== '') {
        return
      }

      const defaultOption = this.actionTextOption[0]
      const participationOption = this.actionTextOption[2] || defaultOption
      const deeplinkOption = this.actionTextOption[1] || defaultOption

      if (this.typeIsParticipation) {
        this.popup.action_text = participationOption
      } else if (this.typeIsDeeplink) {
        this.popup.action_text = deeplinkOption
      } else {
        this.popup.action_text = defaultOption
      }
    },

    saveHypePopupDraft() {
      try {
        const draft = {
          type: 'hypePopup',
          popup: this.popup ? { ...this.popup } : {},
          duration: this.duration ? { ...this.duration } : {},
          additionalOptIns: Array.isArray(this.additionalOptIns) ? [...this.additionalOptIns] : []
        }

        localStorage.setItem('hypePopupDraft', JSON.stringify(draft))
      } catch (err) {
        console.error('Failed to save hype popup draft:', err)
      }
    },

    checkForSavedDraft() {
      const raw = localStorage.getItem('hypePopupDraft')
      if (!raw) return

      try {
        const parsed = JSON.parse(raw)

        if (parsed?.type === 'hypePopup') {
          this.savedDraft = parsed
          this.hasSavedDraft = true
        }
      } catch (e) {
        localStorage.removeItem('hypePopupDraft')
      }
    },

    reuseDraft() {
      if (!this.savedDraft) return

      this.popup = { ...this.savedDraft.popup }
      this.duration = { ...this.savedDraft.duration }
      this.additionalOptIns = [...this.savedDraft.additionalOptIns]

      this.showAdditionalOptInFields = this.additionalOptIns.length > 0
      this.hasSavedDraft = false
      //Reset file data
      this.popup.file = null
    },

    discardDraft() {
      localStorage.removeItem('hypePopupDraft')
      this.savedDraft = null
      this.hasSavedDraft = false
    },

  },
  watch: {
    popupType(newType, oldType) {
      // Don't auto-populate when popup type changes - let user manually enter
      if (newType !== 'deeplink') {
        this.resetSecondLevelState()
        this.popup.selectedShowSection = ''
      }
    },
    actionTextOption(opts) {
      // Don't auto-populate when options load - let user manually enter or change popup type
    },
    'popup.selectedShowSection'(value) {
      this.handleShowSectionChange(value)
    },
    'popup.file'(newFile) {
      if (this.previewImageObjectUrl) {
        URL.revokeObjectURL(this.previewImageObjectUrl)
        this.previewImageObjectUrl = ''
      }
      if (newFile && newFile instanceof File) {
        this.previewImageObjectUrl = URL.createObjectURL(newFile)
      }
    },
  },
};
</script>

<template>
  <b-modal
    id="add_new_hype_popup"
    size="xl"
    v-model="showModal"
    @hidden="resetProps"
    @shown="onHypeModalShown"
    hide-footer
    centered
  >
      <template v-slot:modal-header class="marketing-modal">
        <div class="w-100">
          <h2>Create a Marketing Popup</h2>
          <p>Create engaging popups for your sports club app users</p>
        </div>
        <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
      </template>

    <div v-if="hasSavedDraft" class="alert alert-info d-flex align-items-center justify-content-between p-3 rounded shadow-sm reuse-banner">
      <div class="me-3">
        <h6 class="mb-1 fw-bold">Previous popup data found</h6>
        <p class="mb-0 small text-muted">
          You have saved content from your last marketing popup.
        </p>
      </div>
      <div class="d-flex gap-2">
        <button type="button" class="btn btn-success btn-sm" @click="reuseDraft">
          Reuse Content
        </button>
        <button type="button" class="btn btn-outline-danger btn-sm" @click="discardDraft">
          Discard
        </button>
      </div>
    </div>

      <b-form @submit.prevent="createHypePopUp" class="marketing-modal__hero">
        <div class="row g-4 align-items-start hype-add-two-col">
          <div class="col-12 col-lg-8 hype-add-layout-main">

        <section class="marketing-card">
          <header class="marketing-card__header">
            <h3>Basic Information</h3>
            <p>Essential details about your popup campaign</p>
          </header>

          <b-form-group
            label="Campaign Name"
            label-for="marketing-campaign-name"
            class="mb-4"
          >
            <b-form-input
              id="marketing-campaign-name"
              v-model.trim="popup.name"
              :class="{ 'is-invalid': submitted && $v.popup.name.$error }"
              placeholder="Enter campaign name (internal use only)"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Campaign Name'"
              :validationName="$v.popup.name"
            />
          </b-form-group>

          <div class="mb-1">
            <label class="form-label d-block">Campaign Duration</label>
          </div>

          <div class="row g-3 flex-wrap">
            <div class="col-12 col-lg-6">
              <div class="marketing-datetime">
                <span class="marketing-datetime__label">From</span>
                <div class="marketing-datetime__inputs">
                  <flat-pickr
                    v-model="duration.start_date"
                    :config="startDateConfig"
                    :class="['form-control', submitted && $v.duration.start_date.$error ? 'is-invalid' : '']"
                    placeholder="Pick a date"
                  />
                  <flat-pickr
                    v-model="duration.start_time"
                    :config="timePickerConfig"
                    :class="['form-control', submitted && $v.duration.start_time.$error ? 'is-invalid' : '']"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="marketing-datetime">
                <span class="marketing-datetime__label">To</span>
                <div class="marketing-datetime__inputs">
                  <flat-pickr
                    v-model="duration.end_date"
                    :config="endDateConfig"
                    :class="['form-control', submitted && $v.duration.end_date.$error ? 'is-invalid' : '']"
                    placeholder="Pick a date"
                  />
                  <flat-pickr
                    v-model="duration.end_time"
                    :config="timePickerConfig"
                    :class="['form-control', submitted && $v.duration.end_time.$error ? 'is-invalid' : '']"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="dateRangeError" class="text-danger mt-2">
            {{ dateRangeError }}
          </div>
        </section>

        <div class="card hype-audience-card rounded-3 mb-4">
          <div class="card-body p-4">
            <h6 class="fw-semibold mb-1">Audience Targeting</h6>
            <p class="text-muted small mb-3">Select one audience group for this popup</p>

            <div class="mb-3">
              <label class="form-label small fw-medium mb-2">Recipients</label>
              <select
                v-model="popup.recipient"
                class="form-control form-select hype-audience-field hype-audience-flow-select"
                :class="{ 'is-invalid': submitted && $v.popup.recipient.$error }"
                @change="onRecipientChange"
              >
                <option
                  v-for="opt in recipientOptions"
                  :key="opt.value"
                  :value="opt.value"
                >
                  {{ opt.text }}
                </option>
              </select>
              <validationMessages
                v-if="submitted"
                :fieldName="'Target audience'"
                :validationName="$v.popup.recipient"
              />
            </div>

            <div v-if="hasGroupSelection">
              <label class="form-label small fw-medium mb-2">Audience Group</label>

              <p class="text-muted text-uppercase small fw-semibold mb-2 audience-sub-label">System groups</p>
              <select
                id="hype-audience-system-group"
                v-model="selectedSystemGroupId"
                class="form-select form-control hype-audience-field hype-audience-flow-select audience-system-select mb-3"
                :disabled="!!selectedUserGroup"
                @change="onSystemGroupChange"
              >
                <option value="">Select a system group</option>
                <option
                  v-for="g in systemGroups"
                  :key="g.group_id"
                  :value="g.group_id"
                >
                  {{ g.name }}
                </option>
              </select>

              <div class="audience-or-divider" aria-hidden="true">
                <span></span>
                <strong>OR</strong>
                <span></span>
              </div>

              <p class="text-muted text-uppercase small fw-semibold mb-2 audience-sub-label">
                User created groups
              </p>
              <div class="audience-user-block">
                <div
                  class="audience-user-search-wrap"
                  :class="{ 'audience-user-search-wrap--muted': !!selectedSystemGroupId }"
                >
                  <div class="position-relative">
                    <i
                      class="uil uil-search position-absolute text-muted audience-search-icon"
                      aria-hidden="true"
                    ></i>
                    <input
                      v-model="userGroupSearch"
                      type="text"
                      class="form-control rounded-3 hype-audience-field ps-5 audience-user-search-input"
                      placeholder="Search user created groups..."
                      autocomplete="off"
                      :disabled="!!selectedSystemGroupId"
                    />
                    <ul
                      v-if="filteredUserCreatedForSearch.length > 0 && userGroupSearch.trim() && !selectedSystemGroupId"
                      class="list-group position-absolute w-100 shadow-sm mt-1 audience-suggest-list"
                    >
                      <li
                        v-for="g in filteredUserCreatedForSearch"
                        :key="g.group_id"
                        class="list-group-item list-group-item-action small py-2 cursor-pointer"
                        role="button"
                        @click="pickUserCreatedGroup(g)"
                      >
                        {{ g.name }}
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  v-if="hasActiveAudience && activeAudienceLabel"
                  class="audience-active-pill d-flex align-items-center justify-content-between gap-2 mt-3"
                >
                  <span class="d-flex align-items-center min-w-0 flex-grow-1">
                    <span class="audience-active-dot flex-shrink-0" aria-hidden="true"></span>
                    <span class="audience-active-name small fw-semibold text-truncate">{{ activeAudienceLabel }}</span>
                  </span>
                  <button
                    type="button"
                    class="audience-active-clear flex-shrink-0"
                    aria-label="Clear audience group"
                    @click="clearActiveAudience"
                  >
                    ×
                  </button>
                </div>
              </div>

              <validationMessages
                v-if="submitted && hasGroupSelection"
                :fieldName="'User segment'"
                :validationName="$v.popup.group"
              />
            </div>

            <div class="border rounded-3 p-3 mt-4 audience-estimated-box">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="fw-semibold small">Estimated Audience</span>
              </div>
              <p class="text-muted extra-small mb-2 audience-estimated-footnote">
                * Estimates are for users with the app installed
              </p>
              <div class="text-center fs-1 fw-bold py-1 audience-estimated-value">
                <span v-if="estimatedAudienceLoading" class="d-inline-flex align-items-center justify-content-center gap-2">
                  <b-spinner class="align-middle"></b-spinner>
                </span>
                <span v-else>{{ estimatedAudienceDisplay }}</span>
              </div>
            </div>
          </div>
        </div>

        <section class="marketing-card">
          <header class="marketing-card__header">
            <h3>Popup Type</h3>
            <p>Choose where the popup will redirect users</p>
          </header>

          <b-form-group class="mb-4">
            <b-form-select
              v-model="popupType"
              :options="popupTypeOptions"
              :class="{ 'is-invalid': submitted && $v.popup.type.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Popup type'"
              :validationName="$v.popup.type"
            />
          </b-form-group>

          <b-form-group
            v-if="typeIsUrl || typeIsWebview"
            class="mb-4"
          >
            <b-form-input
              v-model.trim="popup.action"
              placeholder="https://example.com"
            />
          </b-form-group>

          <b-form-group
            v-if="typeIsParticipation"
            label="Participation agreement text"
            class="mb-4"
          >
            <b-form-input
              v-model.trim="popup.participation_agreement_text"
              placeholder="Enter participation agreement text"
              :class="{ 'is-invalid': submitted && $v.popup.participation_agreement_text.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Participation agreement text'"
              :validationName="$v.popup.participation_agreement_text"
            />
          </b-form-group>

          <b-form-group
            v-if="typeIsParticipation"
            label="Terms & Conditions URL"
            class="mb-4"
          >
            <b-form-input
              v-model.trim="popup.participation_tnc_url"
              placeholder="https://example.com/terms"
              :class="{ 'is-invalid': submitted && $v.popup.participation_tnc_url.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Participation T&C URL'"
              :validationName="$v.popup.participation_tnc_url"
            />
          </b-form-group>

          <b-form-group
            v-if="typeIsDeeplink"
            label="App section"
            class="mb-0"
          >
            <b-form-select
              v-model="popup.selectedShowSection"
              :options="showSectionData.map(section => ({ value: section.method, text: section.description }))"
              :class="{ 'is-invalid': submitted && $v.popup.selectedShowSection.$error }"
              placeholder="Select an app section"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'App section'"
              :validationName="$v.popup.selectedShowSection"
            />
          </b-form-group>

          <b-form-group
            v-if="showSecondLevelSelect"
            :label="secondLevelTitle || 'App subsection'"
            class="mt-4 mb-0 position-relative"
          >
            <b-form-select
              v-model="selectedSecondLevel"
              :options="secondLevelOptions.map(option => ({ value: option.id, text: option.name }))"
              :disabled="secondLevelLoading"
              :class="{ 'is-invalid': submitted && $v.selectedSecondLevel.$error }"
            />
            <div v-if="secondLevelLoading" class="select-loader">
              <b-spinner small />
            </div>
            <validationMessages
              v-if="submitted"
              :fieldName="secondLevelTitle || 'App subsection'"
              :validationName="$v.selectedSecondLevel"
            />
          </b-form-group>

          <b-form-group
            label="Button action text"
            label-for="button-action-text"
            class="mt-4 mb-0"
          >
            <b-form-input
              id="button-action-text"
              v-model.trim="popup.action_text"
              placeholder="Enter button action text"
            />
            <small class="form-text text-muted mt-1">
              Leave empty to auto-populate based on popup type
            </small>
          </b-form-group>
        </section>
        <section class="marketing-card">
          <header class="marketing-card__header marketing-card__header--icon">
            <i class="uil uil-image"></i>
            <div>
              <h3>Popup Image</h3>
              <p>Recommended: 980x1080 pixels.</p>
            </div>
          </header>

          <div
            :class="[
              'marketing-upload',
              submitted && $v.popup.file.$error ? 'is-invalid' : '',
              acceptedFileTypeError ? 'has-error' : ''
            ]"
          >
            <vue-dropzone
              id="hype-dropzone"
              ref="hypeDropzone"
              :options="dropzoneOptions"
              :use-custom-slot="true"
              @vdropzone-files-added="selectFile"
              no-progress-bar
            >
              <div class="marketing-upload__placeholder">
                <i class="uil uil-import"></i>
                <span>Drag and drop an image, or click to browse</span>
                <small>PNG, JPG up to 4MB</small>
              </div>
            </vue-dropzone>
          </div>

          <div class="d-flex align-items-center gap-3 mt-3" v-if="popup.file">
            <span class="text-muted small">{{ popup.file.name }}</span>
            <b-button size="sm" variant="outline-danger" @click="removeImage">Remove</b-button>
          </div>

          <validationMessages
            v-if="submitted"
            :fieldName="'Popup image'"
            :validationName="$v.popup.file"
          />
          <p v-if="acceptedFileTypeError" class="text-danger mt-2">{{ acceptedFileTypeErrorMessage }}</p>
        </section>

        <input type="hidden" name="csrf_token" v-model="csrf_token">

        <footer class="marketing-modal__footer">
          <b-button variant="outline-secondary" @click="closeModal">Cancel</b-button>
          <b-button variant="dark" type="submit" :disabled="tryingToSubmit">
            <b-spinner v-if="tryingToSubmit" small class="me-2" />
            Create Popup
          </b-button>
        </footer>

          </div>

          <div class="col-12 col-lg-4 hype-add-preview-sticky">
            <div class="marketing-card hype-add-preview-card mb-3 mb-lg-0">
              <header class="marketing-card__header">
                <h3>Popup preview</h3>
                <p>How your marketing popup looks with app button styling</p>
              </header>

              <div class="position-relative hype-add-preview-inner">
                <div v-if="isLoadingParams" class="hype-add-loader-overlay">
                  <div class="hype-add-loader-content">
                    <b-spinner variant="primary" class="mb-2"></b-spinner>
                    <p class="mb-0 small">Loading preview...</p>
                  </div>
                </div>
                      <div class="preview-popup-modal">
                        <div class="preview-popup-modal__decorative-button">
                          <i class="uil uil-times"></i>
                        </div>

                        <div class="preview-popup-modal__background">
                          <template v-if="getHypePreviewImageUrl()">
                            <img
                              :src="getHypePreviewImageUrl()"
                              :alt="hypePreviewPopupsData.title || 'Popup image'"
                            />
                          </template>
                          <div v-else class="hype-add-preview-placeholder"></div>
                        </div>

                        <div class="preview-popup-modal__body">
                          <div class="preview-popup-modal__actions" v-if="hypePreviewPopupsData.action_text">
                            <button
                              type="button"
                              tabindex="-1"
                              class="preview-popup-modal__button"
                              :style="{
                                backgroundColor: appButtonColor,
                                color: appButtonTextColor
                              }"
                            >
                              {{ formatActionText(hypePreviewPopupsData.action_text) }}
                            </button>
                          </div>

                          <div
                            class="preview-popup-modal__link"
                            v-if="hypePreviewPopupsData.type === 'participation' && hypePreviewPopupsData.participation_tnc_url"
                          >
                            <span class="preview-popup-modal__link-text">
                              Invite your friends for the giveaway!
                            </span>
                          </div>
                        </div>
                      </div>                               
              </div>
            </div>
          </div>

        </div>
      </b-form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="createHypePopUp" :disabled="tryingToSubmit">
        <b-spinner v-show="tryingToSubmit" small></b-spinner>
        Submit</b-button>
    </template>

  </b-modal>
</template>

<style scoped>
.marketing-modal {
  padding: 32px;
  background: #f7f8fb;
}

.marketing-modal__hero {
  margin-bottom: 24px;
}

.marketing-modal__hero h2 {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 8px;
  color: #151a2d;
}

.marketing-modal__hero p {
  margin: 0;
  color: #5f6b7d;
  font-size: 16px;
}

.marketing-card {
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 24px;
  box-shadow: 0 12px 32px rgb(15 23 42 / 6%);
}

.marketing-card__header {
  margin-bottom: 24px;
}

.marketing-card__header h3 {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 600;
  color: #151a2d;
}

.marketing-card__header p {
  margin: 0;
  color: #5f6b7d;
}

.marketing-card__header--icon {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.marketing-card__header--icon i {
  font-size: 32px;
  color: #151a2d;
  line-height: 1;
}

.marketing-datetime {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.marketing-datetime__label {
  font-weight: 600;
  color: #151a2d;
}

.marketing-datetime__inputs {
  display: flex;
  gap: 12px;
  align-items: center;
}

.marketing-datetime__inputs .form-control {
  padding: 12px 16px;
  border-radius: 12px;
  background: #f1f3f7;
  border: 1px solid transparent;
}

.marketing-datetime__inputs .form-control:focus {
  border-color: #6366f1;
  background: #ffffff;
  box-shadow: none;
}

.marketing-upload {
  border: 2px dashed #d3d8e6;
  border-radius: 16px;
  background: #f7f8fb;
  padding: 32px;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.select-loader {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 999px;
}

.marketing-upload.is-invalid {
  border-color: #f97373;
}

.marketing-upload.has-error {
  border-color: #f97373;
  background: #fff5f5;
}

.marketing-upload__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #5f6b7d;
  font-size: 14px;
  text-align: center;
}

.marketing-upload__placeholder i {
  font-size: 32px;
  color: #151a2d;
}

.marketing-upload__placeholder small {
  color: #a0aec0;
}

.marketing-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
}

/* Phone preview sidebar — markup + colors from modalPreviewHypePopUp.vue */
.hype-add-preview-sticky {
  position: sticky;
  top: 1rem;
  z-index: 2;
  align-self: flex-start;
}

.hype-add-preview-inner {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
}

.hype-add-loader-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 12px;
}

.hype-add-loader-content {
  text-align: center;
  color: #5f6b7d;
  font-size: 14px;
}

.hype-add-loading-blur {
  filter: blur(2px);
  opacity: 0.7;
  pointer-events: none;
}

.hype-add-preview-inner .mobile-phone-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  background: #f5f5f5;
}

.hype-add-preview-inner .mobile-phone-frame {
  position: relative;
  width: 100%;
  max-width: 300px;
  background: #5c5d63;
  border-radius: 32px;
  padding: 10px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
}

.hype-add-preview-inner .mobile-phone-screen {
  width: 100%;
  height: min(520px, 58vh);
  max-height: 70vh;
  background: #3a3a3a;
  border-radius: 24px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}

.hype-add-preview-inner .preview-popup-modal {
  position: relative;
  background: #ffffff;
  border-radius: 18px;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  max-height: 96%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  min-height: 320px;
}

.hype-add-preview-inner .preview-popup-modal__decorative-button {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(240, 240, 240, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.hype-add-preview-inner .preview-popup-modal__decorative-button i {
  font-size: 20px;
  color: #ffffff;
  font-weight: 600;
  opacity: 0.6;
}

.hype-add-preview-inner .preview-popup-modal__background {
  position: absolute;
  inset: 0;
  z-index: 1;
  overflow: hidden;
}

.hype-add-preview-inner .preview-popup-modal__background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.hype-add-preview-placeholder {
  position: absolute;
  inset: 0;
  background: linear-gradient(160deg, #e9ecef 0%, #dee2e6 100%);
}

.hype-add-preview-inner .preview-popup-modal__body {
  position: relative;
  z-index: 2;
  padding: 20px 16px;
  flex: 1;
  overflow-y: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 100%;
}

.hype-add-preview-inner .preview-popup-modal__actions {
  margin-bottom: 10px;
}

.hype-add-preview-inner .preview-popup-modal__button {
  width: 100%;
  padding: 10px 20px;
  border: none;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  cursor: default;
}

.hype-add-preview-inner .preview-popup-modal__link {
  text-align: center;
  margin-top: 4px;
}

.hype-add-preview-inner .preview-popup-modal__link-text {
  color: #ff6b35;
  text-decoration: underline;
  font-size: 13px;
}

@media (max-width: 767.98px) {
  .marketing-modal {
    padding: 20px;
  }

  .marketing-card {
    padding: 20px;
  }

  .marketing-datetime__inputs {
    flex-direction: column;
    align-items: stretch;
  }
}

/* Audience targeting — matches modalAddPushNotification */
.hype-audience-card {
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: none;
}

.hype-audience-card .extra-small {
  font-size: 0.7rem;
}

.hype-audience-card select.hype-audience-field,
.hype-audience-card input.form-control.hype-audience-field,
.hype-audience-card textarea.form-control.hype-audience-field {
  background-color: #f3f3f5 !important;
  border-color: rgba(0, 0, 0, 0.06) !important;
}

.hype-audience-card select.hype-audience-field,
.hype-audience-card input.form-control.hype-audience-field {
  min-height: 42px;
}

.hype-audience-card select.hype-audience-field:focus,
.hype-audience-card input.form-control.hype-audience-field:focus,
.hype-audience-card textarea.form-control.hype-audience-field:focus {
  background-color: #f3f3f5 !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  box-shadow: none !important;
}

.hype-audience-card .form-select {
  border-radius: 10px;
}

.audience-sub-label {
  letter-spacing: 0.03em;
  font-size: 0.7rem;
}

.audience-search-icon {
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 1;
}

.audience-suggest-list {
  z-index: 20;
  max-height: 220px;
  overflow-y: auto;
  border-radius: 0.375rem;
}

.audience-estimated-box {
  background-color: #f3f3f5;
}

.cursor-pointer {
  cursor: pointer;
}

.audience-user-search-wrap--muted .audience-user-search-input {
  opacity: 0.75;
  cursor: not-allowed !important;
}

.audience-or-divider {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 0.75rem;
  margin: 0.25rem 0 1rem;
  color: #6c757d;
}

.audience-or-divider span {
  height: 1px;
  background: #dee2e6;
}

.audience-or-divider strong {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.audience-active-pill {
  padding: 0.65rem 0.85rem;
  border-radius: 10px;
  border: 1px solid #b6d4fe;
  background-color: #e8f2fc;
}

.audience-active-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #0d6efd;
  margin-right: 0.65rem;
}

.audience-active-name {
  color: #212529;
}

.audience-active-clear {
  border: none;
  background: transparent;
  padding: 0 0.15rem;
  margin: 0;
  line-height: 1;
  font-size: 1.35rem;
  font-weight: 400;
  color: #0d6efd;
  cursor: pointer;
  border-radius: 6px;
}

.audience-active-clear:hover {
  color: #0a58ca;
  background-color: rgba(13, 110, 253, 0.1);
}

.audience-estimated-footnote {
  line-height: 1.35;
}
</style>